import React from 'react';

const Privacy = () => {
    return (
        <div className="container-xxl py-5">
            <div className="container">
                <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
                    <h6 className="section-title bg-white text-center text-primary px-3">Legal</h6>
                    <h1 className="mb-5">Privacy Policy</h1>
                </div>
                <div className="row g-4">
                    <div className="col-lg-12">
                        <h2>1. Introduction</h2>
                        <p>
                            Welcome to Fundisha. We are committed to protecting your personal information and your right to privacy. If you have any questions or concerns about our policy, or our practices with regards to your personal information, please contact us.
                        </p>

                        <h2>2. Information We Collect</h2>
                        <p>
                            We collect personal information that you voluntarily provide to us when you register on the platform, express an interest in obtaining information about us or our products and services, when you participate in activities on the platform or otherwise when you contact us.
                        </p>
                        <p>
                            The personal information that we collect depends on the context of your interactions with us and the platform, the choices you make and the products and features you use. The personal information we collect may include the following: Name, Email Address, Phone Number, Payment Information, etc.
                        </p>

                        <h2>3. How We Use Your Information</h2>
                        <p>
                            We use personal information collected via our platform for a variety of business purposes described below. We process your personal information for these purposes in reliance on our legitimate business interests, in order to enter into or perform a contract with you, with your consent, and/or for compliance with our legal obligations.
                        </p>
                        <ul>
                            <li>To facilitate account creation and logon process.</li>
                            <li>To send you marketing and promotional communications.</li>
                            <li>To send administrative information to you.</li>
                            <li>To protect our Services.</li>
                            <li>To enforce our terms, conditions and policies for business purposes, to comply with legal and regulatory requirements or in connection with our contract.</li>
                            <li>To respond to legal requests and prevent harm.</li>
                        </ul>

                        <h2>4. Will Your Information Be Shared With Anyone?</h2>
                        <p>
                            We only share information with your consent, to comply with laws, to provide you with services, to protect your rights, or to fulfill business obligations.
                        </p>

                        <h2>5. How Long Do We Keep Your Information?</h2>
                        <p>
                            We will only keep your personal information for as long as it is necessary for the purposes set out in this privacy policy, unless a longer retention period is required or permitted by law (such as tax, accounting or other legal requirements).
                        </p>

                        <h2>6. How Do We Keep Your Information Safe?</h2>
                        <p>
                            We have implemented appropriate technical and organizational security measures designed to protect the security of any personal information we process. However, despite our safeguards and efforts to secure your information, no electronic transmission over the Internet or information storage technology can be guaranteed to be 100% secure.
                        </p>

                        <h2>7. Contact Us</h2>
                        <p>
                            If you have questions or comments about this policy, you may email us at privacy@fundisha.com.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Privacy; 